export enum ChartType {
    BAR = 'bar',
    BUBBLE = 'bubble',
    DOUGHNUT = 'doughnut',
    LINE = 'line',
    POLARAREA = 'polarArea',
    RADAR = 'radar',
    SCATTER = 'scatter',
}